import React from "react";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router";

import { ErrorBoundary } from "@/components/ErrorBoundary";
import { EstimateTrackerNav } from "./EstimateTrackerNav";
import { EstimateTrackerPage } from "./EstimateTrackerPage";

export const EstimateTrackerLayout: React.FC = () => {
  return (
    <div className="d-flex h-100">
      <div className="flex-grow-0 flex-shrink-0 bg-secondary-subtle py-3 me-3">
        <EstimateTrackerNav />
      </div>
      <Container fluid className="flex-grow-1 overflow-y-auto py-3">
        <ErrorBoundary>
          <EstimateTrackerPage>
            <Outlet />
          </EstimateTrackerPage>
        </ErrorBoundary>
      </Container>
    </div>
  );
};
